import * as React from 'react'
import { Slot } from '@radix-ui/react-slot'
import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '../../lib/utils'
import { Fragment } from 'react'
import { DotFallingLoader } from '../loading'

const buttonVariants = cva(
  'bg-blend-overlay text-center  font-bold inline-flex items-center justify-center hover:cursor-pointer disabled:cursor-not-allowed  whitespace-nowrap  transition-colors focus-visible:outline-none  focus-visible:ring-ring  disabled:bg-disabled-surface-20 disabled:text-disabled-main-dark disabled:border-0 [&_svg]:pointer-events-none  [&_svg]:shrink-0',
  {
    variants: {
      variant: {
        fill: 'border',
        ghost: 'border',
        outline: 'border',
        transparent: '',
      },

      size: {
        xs: 'rounded-xs  p-3xs text-xs ![&_svg]:size-icon-xs  gap-3xs min-h-[24px]',
        sm: 'rounded-xs  p-2xs text-sm ![&_svg]:size-icon-sm  gap-3xs min-h-[32px]',
        md: 'rounded-sm  p-xs text-md  ![&_svg]:size-icon-md  gap-2xs min-h-[40px]',
        lg: 'rounded-sm  p-xs text-lg  ![&_svg]:size-icon-md  gap-xs min-h-[44px]',
      },
      width: {
        auto: 'w-fit',
        full: 'w-full',
      },
      color: {
        base: '',
        neutral: '',
        positive: '',
        negative: '',
        alert: '',
      },
    },
    compoundVariants: [
      {
        variant: 'fill',
        color: 'base',
        className:
          'bg-base-main hover:bg-base-main-dark gradient-to-b from-white-30 active:from-black-5 to-white-0 active:from-black-10 border-base-main-dark hover:border-base-main-light active:border-base-main-dark text-base-main-100 active:text-base-main-60 [&_svg]:fill-base-main-100 active:[&_svg]:fill-base-main-60',
      },
      {
        variant: 'ghost',
        color: 'base',
        className:
          'bg-base-surface hover:bg-base-surface-dark gradient-to-b from-white-30 active:from-black-5 to-white-0 active:from-black-10 border-base-surface-dark hover:border-base-surface-dark active:border-base-surface text-base-surface-100 active:text-base-surface-60 [&_svg]:fill-base-surface-100 active:[&_svg]:fill-base-surface-60',
      },
      {
        variant: 'transparent',
        color: 'base',
        className:
          'bg-transparent hover:bg-base-surface active:bg-base-surface-dark hover:bg-gradient-to-b active:bg-gradient-to-b  hover:from-white-10 active:from-white-30  hover:to-white-0  active:to-white-0 text-base-surface-100 active:text-base-surface-60 [&_svg]:fill-base-surface-100 active:[&_svg]:fill-base-surface-60',
      },
      {
        variant: 'outline',
        color: 'base',
        className:
          'bg-transparent hover:bg-base-surface active:bg-base-surface-dark hover:bg-gradient-to-b active:bg-gradient-to-b  hover:from-white-10 active:from-white-30  hover:to-white-0  active:to-white-0 text-base-surface-100 active:text-base-surface-60 [&_svg]:fill-base-surface-100 active:[&_svg]:fill-base-surface-60 border-base-surface-dark hover:border-base-surface active:border-base-surface',
      },
      {
        variant: 'fill',
        color: 'neutral',
        className:
          'bg-neutral-main hover:bg-neutral-main-dark gradient-to-b hover:from-white-30 active:from-black-5 hover:to-white-0 active:from-black-10 border-neutral-main-dark hover:border-neutral-main-light active:border-neutral-main-dark text-neutral-main-100 active:text-neutral-main-60 [&_svg]:fill-neutral-main-100 active:[&_svg]:fill-neutral-main-60',
      },
      {
        variant: 'ghost',
        color: 'neutral',
        className:
          'bg-neutral-surface hover:bg-neutral-surface-dark gradient-to-b from-white-30 active:from-black-5 to-white-0 active:from-black-10 border-neutral-surface-dark hover:border-neutral-surface-dark active:border-neutral-surface text-neutral-surface-100 active:text-neutral-surface-60 [&_svg]:fill-neutral-surface-100 active:[&_svg]:fill-neutral-surface-60',
      },
      {
        variant: 'transparent',
        color: 'neutral',
        className:
          'bg-transparent hover:bg-neutral-surface active:bg-neutral-surface-dark hover:bg-gradient-to-b active:bg-gradient-to-b  hover:from-white-10 active:from-white-30  hover:to-white-0  active:to-white-0 text-neutral-surface-100 active:text-neutral-surface-60 [&_svg]:fill-neutral-surface-100 active:[&_svg]:fill-neutral-surface-60',
      },
      {
        variant: 'outline',
        color: 'neutral',
        className:
          'bg-transparent hover:bg-neutral-surface active:bg-neutral-surface-dark hover:bg-gradient-to-b active:bg-gradient-to-b  hover:from-white-10 active:from-white-30  hover:to-white-0  active:to-white-0 text-neutral-surface-100 active:text-neutral-surface-60 [&_svg]:fill-neutral-surface-100 active:[&_svg]:fill-neutral-surface-60 border-neutral-surface-dark hover:border-neutral-surface active:border-neutral-surface',
      },
      {
        variant: 'fill',
        color: 'positive',
        className:
          'bg-positive-main hover:bg-positive-main-dark gradient-to-b from-white-30 active:from-black-5 to-white-0 active:from-black-10 border-positive-main-dark hover:border-positive-main-light active:border-positive-main-dark text-positive-main-100 active:text-positive-main-60 [&_svg]:fill-positive-main-100 active:[&_svg]:fill-positive-main-60',
      },
      {
        variant: 'ghost',
        color: 'positive',
        className:
          'bg-positive-surface hover:bg-positive-surface-dark gradient-to-b from-white-30 active:from-black-5 to-white-0 active:from-black-10 border-positive-surface-dark hover:border-positive-surface-dark active:border-positive-surface text-positive-surface-100 active:text-positive-surface-60 [&_svg]:fill-positive-surface-100 active:[&_svg]:fill-positive-surface-60',
      },
      {
        variant: 'transparent',
        color: 'positive',
        className:
          'bg-transparent hover:bg-positive-surface active:bg-positive-surface-dark hover:bg-gradient-to-b active:bg-gradient-to-b  hover:from-white-10 active:from-white-30  hover:to-white-0  active:to-white-0 text-positive-surface-100 active:text-positive-surface-60 [&_svg]:fill-positive-surface-100 active:[&_svg]:fill-positive-surface-60',
      },
      {
        variant: 'outline',
        color: 'positive',
        className:
          'bg-transparent hover:bg-positive-surface active:bg-positive-surface-dark hover:bg-gradient-to-b active:bg-gradient-to-b  hover:from-white-10 active:from-white-30  hover:to-white-0  active:to-white-0 text-positive-surface-100 active:text-positive-surface-60 [&_svg]:fill-positive-surface-100 active:[&_svg]:fill-positive-surface-60 border-positive-surface-dark hover:border-positive-surface active:border-positive-surface',
      },
      {
        variant: 'fill',
        color: 'negative',
        className:
          'bg-negative-main hover:bg-negative-main-dark gradient-to-b from-white-30 active:from-black-5 to-white-0 active:from-black-10 border-negative-main-dark hover:border-negative-main-light active:border-negative-main-dark text-negative-main-100 active:text-negative-main-60 [&_svg]:fill-negative-main-100 active:[&_svg]:fill-negative-main-60',
      },
      {
        variant: 'ghost',
        color: 'negative',
        className:
          'bg-negative-surface hover:bg-negative-surface-dark gradient-to-b from-white-30 active:from-black-5 to-white-0 active:from-black-10 border-negative-surface-dark hover:border-negative-surface-dark active:border-negative-surface text-negative-surface-100 active:text-negative-surface-60 [&_svg]:fill-negative-surface-100 active:[&_svg]:fill-negative-surface-60',
      },
      {
        variant: 'transparent',
        color: 'negative',
        className:
          'bg-transparent hover:bg-negative-surface active:bg-negative-surface-dark hover:bg-gradient-to-b active:bg-gradient-to-b  hover:from-white-10 active:from-white-30  hover:to-white-0  active:to-white-0 text-negative-surface-100 active:text-negative-surface-60 [&_svg]:fill-negative-surface-100 active:[&_svg]:fill-negative-surface-60',
      },
      {
        variant: 'outline',
        color: 'negative',
        className:
          'bg-transparent hover:bg-negative-surface active:bg-negative-surface-dark hover:bg-gradient-to-b active:bg-gradient-to-b  hover:from-white-10 active:from-white-30  hover:to-white-0  active:to-white-0 text-negative-surface-100 active:text-negative-surface-60 [&_svg]:fill-negative-surface-100 active:[&_svg]:fill-negative-surface-60 border-negative-surface-dark hover:border-negative-surface active:border-negative-surface',
      },
      {
        variant: 'fill',
        color: 'alert',
        className:
          'bg-alert-main hover:bg-alert-main-dark gradient-to-b from-white-30 active:from-black-5 to-white-0 active:from-black-10 border-alert-main-dark hover:border-alert-main-light active:border-alert-main-dark text-alert-main-100 active:text-alert-main-60 [&_svg]:fill-alert-main-100 active:[&_svg]:fill-alert-main-60',
      },
      {
        variant: 'ghost',
        color: 'alert',
        className:
          'bg-alert-surface hover:bg-alert-surface-dark gradient-to-b from-white-30 active:from-black-5 to-white-0 active:from-black-10 border-alert-surface-dark hover:border-alert-surface-dark active:border-alert-surface text-alert-surface-100 active:text-alert-surface-60 [&_svg]:fill-alert-surface-100 active:[&_svg]:fill-alert-surface-60',
      },
      {
        variant: 'transparent',
        color: 'alert',
        className:
          'bg-transparent hover:bg-alert-surface active:bg-alert-surface-dark hover:bg-gradient-to-b active:bg-gradient-to-b  hover:from-white-10 active:from-white-30  hover:to-white-0  active:to-white-0 text-alert-surface-100 active:text-alert-surface-60 [&_svg]:fill-alert-surface-100 active:[&_svg]:fill-alert-surface-60 ',
      },
      {
        variant: 'outline',
        color: 'alert',
        className:
          'bg-transparent hover:bg-alert-surface active:bg-alert-surface-dark hover:bg-gradient-to-b active:bg-gradient-to-b  hover:from-white-10 active:from-white-30  hover:to-white-0  active:to-white-0 text-alert-surface-100 active:text-alert-surface-60 [&_svg]:fill-alert-surface-100 active:[&_svg]:fill-alert-surface-60 border-alert-surface-dark hover:border-alert-surface active:border-alert-surface',
      },
    ],
    defaultVariants: {
      variant: 'fill',
      size: 'md',
      color: 'base',
      width: 'auto',
    },
  },
)
// const buttonContentVariants = (
//   size: 'xs' | 'sm' | 'md' | 'lg',
//   startIcon: React.ReactNode,
//   endIcon: React.ReactNode,
// ) => {
//   if (!startIcon && !endIcon) {
//     return size === 'xs'
//       ? 'px-[0.5rem]'
//       : size === 'sm'
//         ? 'px-[1.25rem]'
//         : size === 'md'
//           ? 'px-[1.5rem]'
//           : ''
//   }
//   if (startIcon || endIcon) {
//     return size === 'xs'
//       ? 'px-[0.25rem]'
//       : size === 'sm'
//         ? 'px-[0.625rem]'
//         : size === 'md'
//           ? 'px-[0.75rem]'
//           : ''
//   }
// }

export type ButtonVariants = VariantProps<typeof buttonVariants>

export interface ButtonProps
  extends Omit<
      React.ButtonHTMLAttributes<HTMLButtonElement>,
      keyof ButtonVariants
    >,
    ButtonVariants {
  asChild?: boolean
  startIcon?: React.ReactNode
  endIcon?: React.ReactNode
  loading?: boolean
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      className,
      variant,
      size,
      width,
      color,
      asChild = false,
      startIcon,
      endIcon,
      children,
      loading = false,
      ...props
    },
    ref,
  ) => {
    const Comp = asChild ? Slot : 'button'
    const NestComp = asChild ? 'span' : Fragment
    return (
      <Comp
        ref={ref}
        data-slot='button'
        className={cn(
          buttonVariants({ variant, size, color, width }),
          // buttonContentVariants(size || 'md', startIcon, endIcon),
          className,
          loading && 'pointer-events-none opacity-50',
        )}
        {...props}
        disabled={loading ? false : props.disabled}
        data-loading={loading}
      >
        <NestComp>
          {!loading && startIcon}
          {loading ? (
            <DotFallingLoader
              size={
                size === 'xs'
                  ? 'xs'
                  : size === 'sm'
                    ? 'sm'
                    : size === 'lg'
                      ? 'lg'
                      : 'md'
              }
              color='current'
              className='-mt-3'
            />
          ) : (
            children
          )}
          {!loading && endIcon}
        </NestComp>
      </Comp>
    )
  },
)

Button.displayName = 'Button'

export { Button, buttonVariants }
